import request from './request';


/**
 * 报价记录列表信息
 */
export function getInsuranceQuote(params) {
    return request('/insurance/quote/list', {
        method: 'POST',
        params,
    });
}
/**
 * 报价详情
 */
export function getInsuranceQuoteItem(params) {
    return request('/insurance/quote/item', {
        method: 'GET',
        params,
    });
}
